var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t("buttons.login")))]),_c('p',[_vm._v(_vm._s(_vm.$t("loginDesc")))]),_c('sign-in1-form',{attrs:{"formType":"jwt","email":"admin@xray.com","password":"admin123"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }